import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const FIELDS = [
  { k: "company_name", label: "Company name" },
  { k: "address", label: "Address", ta: true },
  { k: "phone", label: "Phone" },
  { k: "email", label: "Email" },
  { k: "gst_number", label: "GST number" },
  { k: "logo_url", label: "Logo image URL" },
  { k: "bank_name", label: "Bank name" },
  { k: "account_holder", label: "Account holder" },
  { k: "account_no", label: "Account number" },
  { k: "ifsc", label: "IFSC" },
  { k: "upi_id", label: "UPI ID" },
  { k: "payment_qr_url", label: "Payment QR image URL" },
  { k: "google_review_url", label: "Google Review URL (auto-open on 4/5 stars)" },
  { k: "map_link", label: "Company map link (Google Maps URL for delivery route)" },
  { k: "quote_terms", label: "Quote — Terms & Conditions", ta: true },
  { k: "po_terms", label: "Purchase Order — Terms", ta: true },
  { k: "invoice_terms", label: "Invoice — Terms", ta: true },
  { k: "dc_terms", label: "Delivery Challan — Terms", ta: true },
];

export default function Settings() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings").then(r => setS(r.data)); }, []);
  if (!s) return <div className="p-8 text-[#757169]">Loading…</div>;

  const save = async (e) => {
    e.preventDefault();
    try { await api.put("/settings", s); toast.success("Settings saved"); }
    catch(e){ toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="space-y-6">
      <div>
        <div className="label-tiny mb-1">Admin only</div>
        <h1 className="font-display text-3xl tracking-tight">Company Settings</h1>
      </div>
      <form onSubmit={save} className="card-surface p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
        {FIELDS.map(f => (
          <div key={f.k} className={f.ta ? "md:col-span-2" : ""}>
            <div className="label-tiny mb-1.5">{f.label}</div>
            {f.ta ? (
              <textarea rows={3} className="input-field" value={s[f.k]||""} onChange={e=>setS({...s,[f.k]:e.target.value})}/>
            ) : (
              <input className="input-field" value={s[f.k]||""} onChange={e=>setS({...s,[f.k]:e.target.value})}/>
            )}
          </div>
        ))}
        <div className="md:col-span-2 flex justify-end">
          <button className="btn-primary" data-testid="settings-save">Save changes</button>
        </div>
      </form>
    </div>
  );
}
